import { useState } from "react"
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai"
import { useDispatch } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import image1 from "../../../Assets/TimelineImage.png"

import { login } from "../../../services/operations/authAPI"

function LoginForm() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  })

  const [showPassword, setShowPassword] = useState(false)

  const { email, password } = formData

  const handleOnChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }))
  }

  const handleOnSubmit = (e) => {
    e.preventDefault()
    dispatch(login(email, password, navigate))
  }

  return (
    <div className="flex lg:flex-row  flex-col items-center justify-center gap-10">
    <div className="lg:w-[45%] mt-10 shadow-[0px_0px_20px_10px_#ecc94b] rounded-lg">
      <img src={image1} alt="image" className="rounded-2xl" />
    </div>
    
     <form
      onSubmit={handleOnSubmit}
      className="mt-6 flex lg:w-[45%] flex-col gap-y-4 "
    >
    <p className="text-[#CFAB08] text-5xl font-bold">Admin Only can login</p>
      <label className="w-full">
        <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-500">
          Email Address <sup className="text-[#CFAB08]">*</sup>
        </p>
        <input
          required
          type="text"
          name="email"
          value={email}
          onChange={handleOnChange}
          placeholder="Enter email address"
          style={{
            boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
          }}
          className="w-full rounded-[0.5rem] bg-white border-richblack-500 border-2 p-[12px] text-richblack-500"
        />
      </label>
      <label className="relative">
        <p className="mb-1 text-[0.875rem] leading-[1.375rem] text-richblack-500">
          Password <sup className="text-[#CFAB08]">*</sup>
        </p>
        <input
          required
          type={showPassword ? "text" : "password"}
          name="password"
          value={password}
          onChange={handleOnChange}
          placeholder="Enter Password"
          style={{
            boxShadow: "inset 0px -1px 0px rgba(255, 255, 255, 0.18)",
          }}
          className="w-full rounded-[0.5rem] bg-white border-richblack-500 border-2 p-[12px] pr-12 text-richblack-500"
        />
        <span
          onClick={() => setShowPassword((prev) => !prev)}
          className="absolute right-3 top-[38px] z-[10] cursor-pointer"
        >
          {showPassword ? (
            <AiOutlineEyeInvisible fontSize={24} fill="#AFB2BF" />
          ) : (
            <AiOutlineEye fontSize={24} fill="#AFB2BF" />
          )}
        </span>
        <Link to="/forgot-password">
          <p className="mt-1 ml-auto max-w-max text-xs text-[#CFAB08]">
            Forgot Password
          </p>
        </Link>
      </label>
      <button
        type="submit"
        className="mt-6 rounded-[8px] w-[10rem] bg-[#CFAB08] py-[8px] px-[12px] font-medium text-xl text-richblack-5"
      >
        Sign In
      </button>
    </form>
    
    </div>
   
  )
}

export default LoginForm